import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-default-react-imports */
import { createContext, useContext, useEffect, useState } from 'react';
import { breakpointValues } from '../constants/Breakpoints';
export const IsMobileContext = /*#__PURE__*/createContext({
  isMobile: false,
  isMon569Mobile: false
});
export const useIsMobile = () => {
  const {
    isMobile
  } = useContext(IsMobileContext);
  return isMobile;
};

const IsMobileContextProvider = ({
  children
}) => {
  const isWindowMobileWidth = () => window.innerWidth <= breakpointValues.tabletPortrait;

  const isWindowMon569MobileWidth = () => window.innerWidth <= breakpointValues.mon569;

  const [isMobile, setIsMobile] = useState(isWindowMobileWidth());
  const [isMon569Mobile, setIsMon569Mobile] = useState(isWindowMon569MobileWidth());
  useEffect(() => {
    const mobileCheck = () => {
      if (isWindowMobileWidth() !== isMobile) setIsMobile(isWindowMobileWidth());
    };

    const mon569MobileCheck = () => {
      if (isWindowMon569MobileWidth() !== isMon569Mobile) setIsMon569Mobile(isWindowMon569MobileWidth());
    };

    window.addEventListener('resize', mobileCheck);
    window.addEventListener('resize', mon569MobileCheck);
    return () => {
      window.removeEventListener('resize', mobileCheck);
      window.removeEventListener('resize', mon569MobileCheck);
    };
  });
  const value = {
    isMobile,
    isMon569Mobile
  };
  return /*#__PURE__*/_jsx(IsMobileContext.Provider, {
    value: value,
    children: children
  });
};

export default IsMobileContextProvider;